import React, { useState } from "react";
import { ChevronDown, ChevronRight, FilePlus, FileMinus, FileEdit, ArrowRight } from "lucide-react";
import { Badge } from "@shadcn-in-nx/ui/badge";

const STATUS_CONFIG = {
    added: { label: "Added", className: "bg-green-100 text-green-700", Icon: FilePlus },
    modified: { label: "Modified", className: "bg-blue-100 text-blue-700", Icon: FileEdit },
    removed: { label: "Removed", className: "bg-red-100 text-red-700", Icon: FileMinus },
    renamed: { label: "Renamed", className: "bg-yellow-100 text-yellow-700", Icon: ArrowRight },
    "renamed+modified": { label: "Renamed+Modified", className: "bg-orange-100 text-orange-700", Icon: ArrowRight },
};

const LINE_STYLES = {
    add: "bg-green-50 text-green-800",
    remove: "bg-red-50 text-red-800",
    context: "text-gray-600",
    "hunk-header": "bg-blue-50 text-blue-600",
};

const LINE_PREFIX = { add: "+", remove: "-", context: " ", "hunk-header": "@@" };

function FileDiffViewer({ change }) {
    const [open, setOpen] = useState(false);
    const config = STATUS_CONFIG[change.status] || STATUS_CONFIG.modified;
    const hasLines = change.lines?.length > 0;

    const isRenamed = change.status === "renamed" || change.status === "renamed+modified";
    const displayName = isRenamed && change.oldFileName
        ? `${change.oldFileName} → ${change.fileName}`
        : change.fileName;

    return (
        <div className="border rounded overflow-hidden">
            <button
                onClick={() => hasLines && setOpen((p) => !p)}
                className="flex items-center gap-2 text-xs py-1.5 px-2 w-full hover:bg-gray-50 transition-colors"
            >
                {hasLines ? (
                    open ? <ChevronDown className="h-3 w-3 shrink-0" /> : <ChevronRight className="h-3 w-3 shrink-0" />
                ) : (
                    <config.Icon className="h-3 w-3 text-gray-400 shrink-0" />
                )}
                <span className="truncate flex-1 text-left text-gray-700">{displayName}</span>
                <Badge variant="outline" className={`text-[10px] px-1.5 py-0 ${config.className}`}>
                    {config.label}
                </Badge>
                <span className="text-green-600 tabular-nums">+{change.additions}</span>
                <span className="text-red-600 tabular-nums">-{change.deletions}</span>
            </button>
            {open && hasLines && (
                <div className="border-t max-h-64 overflow-auto">
                    <pre className="text-[11px] leading-[18px] font-mono">
                        {change.lines.map((line, i) => (
                            <div key={i} className={`px-2 ${LINE_STYLES[line.type] || ""}`}>
                                <span className="select-none text-gray-400 mr-2 inline-block w-3">
                                    {LINE_PREFIX[line.type]}
                                </span>
                                {line.content}
                            </div>
                        ))}
                    </pre>
                </div>
            )}
        </div>
    );
}

export default FileDiffViewer;
